import { render, staticRenderFns } from "./VATSelector.vue?vue&type=template&id=107997db"
import script from "./VATSelector.vue?vue&type=script&lang=js"
export * from "./VATSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports